export const GET_HELP_REQUEST = 'GET_HELP_REQUEST'
export const GET_HELP_REQUESTS = 'GET_HELP_REQUESTS'
export const GET_HELP_REQUESTS_TASK_ARE_ASSIGNED_TO = 'GET_HELP_REQUESTS_TASK_ARE_ASSIGNED_TO'
export const GET_ALL_HELP_REQUESTS = 'GET_ALL_HELP_REQUESTS'
export const UPDATE_HELP_REQUESTS = 'UPDATE_HELP_REQUESTS'
export const DELETE_HELP_REQUESTS = 'DELETE_HELP_REQUESTS'
export const CREATE_HELP_REQUESTS = 'CREATE_HELP_REQUESTS'
export const RESET_HELP_REQUESTS = 'RESET_HELP_REQUESTS'

export const GET_SCREENSHOT_IMAGE = 'GET_SCREENSHOT_IMAGE'
